import type React from 'react';

import { TemperatureIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface TemperatureAttributeCardProps extends WithDataTestid, WithClassNameProp {
  temperature: number | null;
}

export function TemperatureAttributeCard({
  temperature,
  className = undefined,
  'data-testid': dataTestId = 'TemperatureAttributeCard',
  ...props
}: TemperatureAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <AttributeCard
      className={className}
      data={temperature}
      data-testid={dataTestId}
      description={`${temperature}°C`}
      icon={<TemperatureIcon />}
      title={t('shared:attribute_cards.temperature.title')}
      {...props}
    />
  );
}
